<template>
  <core-modal-marketing
    v-if="project.userNeedsToBuyStorage"
    :tag="STORAGE_UPSELL_MARKETING.tag"
    :tag-icon="STORAGE_UPSELL_MARKETING.icon"
    :subtitle="STORAGE_UPSELL_MARKETING.subtitle"
    :header-icon="STORAGE_UPSELL_MARKETING.icon"
  >
    <template #title>
      Save Your Digitized Memories FOREVER<sub class="reg-mark">®</sub>
    </template>

    <div class="text-center">
      <digitization-storage-selection
        :project="project"
        :one-time-payment-products="project.products.storageOneTime"
        :monthly-payment-products="project.products.storageInstallment"
        :upsell-tracking="upsellTracking"
      />
      <p class="mt-7">Questions? Call us at 1-888-FOREVER.</p>
    </div>
  </core-modal-marketing>

  <div v-else class="pt-12 p-3 sm:p-12 text-center">
    <core-logo class="mx-auto max-w-[184px] mb-3" />
    <h1 class="font-serif text-3xl sm:text-4xl mb-3">Yay! You have enough storage space!</h1>
    <digitization-make-permanent
      :project="project"
      :upsell-tracking="makePermanentStorageTracking"
      @made-permanent="() => modal.close()"
    />
  </div>
</template>

<script setup>
  const props = defineProps({
    project: Object,
    modal: Object,
    upsellTracking: Object
  });

  const makePermanentStorageTracking = {
    type: UPSELL_TYPES.storage,
    context: STORAGE_UPSELL_CTA_CONTEXTS.digitizationProjectMakePermanent
  };
</script>
